(() => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;

  const dataNode = root.querySelector('[data-product-json]');
  const product = dataNode ? JSON.parse(dataNode.textContent) : null;
  const select = root.querySelector('[name="id"]');
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-compare-price]');
  const submit = root.querySelector('[data-add-to-cart]');
  const mainImage = root.querySelector('[data-product-main-image]');
  const quantity = root.querySelector('[name="quantity"]');
  const galleryButtons = [...root.querySelectorAll('[data-gallery-image]')];
  if (!product || !select) return;

  let galleryIndex = Math.max(0, galleryButtons.findIndex((button) => button.getAttribute('aria-current') === 'true'));

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents || 0) / 100);

  const showGalleryImage = (index, { animate = true } = {}) => {
    if (!galleryButtons.length || !mainImage) return;
    galleryIndex = (index + galleryButtons.length) % galleryButtons.length;
    const button = galleryButtons[galleryIndex];
    mainImage.removeAttribute('srcset');
    mainImage.src = button.dataset.galleryImage;
    mainImage.alt = button.dataset.galleryAlt || product.title;
    mainImage.dataset.galleryImageId = button.dataset.galleryImageId || '';
    galleryButtons.forEach((item, itemIndex) => item.setAttribute('aria-current', String(itemIndex === galleryIndex)));
    if (animate) {
      mainImage.animate([
        { opacity: .58, transform: 'scale(.985)' },
        { opacity: 1, transform: 'scale(1)' }
      ], { duration: 220, easing: 'ease-out' });
    }
  };

  const showVariantImage = (variant) => {
    const imageId = variant.featured_image?.id;
    const galleryMatch = galleryButtons.findIndex((button) => String(button.dataset.galleryImageId) === String(imageId));
    if (galleryMatch >= 0) {
      showGalleryImage(galleryMatch);
      return;
    }
    if (variant.featured_image?.src && mainImage) {
      mainImage.removeAttribute('srcset');
      mainImage.src = `${variant.featured_image.src}&width=1400`;
      mainImage.dataset.galleryImageId = String(imageId || '');
    }
  };

  const setVariant = (id, { updateImage = true } = {}) => {
    const variant = product.variants.find((item) => String(item.id) === String(id));
    if (!variant) return;
    select.value = variant.id;
    price.textContent = money(variant.price);
    if (compare) {
      compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      compare.hidden = !(variant.compare_at_price > variant.price);
    }
    submit.disabled = !variant.available;
    submit.dataset.unavailable = String(!variant.available);
    submit.textContent = variant.available ? `ADD ${variant.title.toUpperCase()} TO BAG — ${money(variant.price)}` : 'SOLD OUT';
    root.querySelectorAll('[data-variant-id]').forEach((button) => {
      const selected = String(button.dataset.variantId) === String(variant.id);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    if (updateImage) showVariantImage(variant);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  root.addEventListener('click', (event) => {
    const variant = event.target.closest('[data-variant-id]');
    if (variant) {
      setVariant(variant.dataset.variantId);
      return;
    }

    const thumb = event.target.closest('[data-gallery-image]');
    if (thumb) {
      showGalleryImage(galleryButtons.indexOf(thumb));
      return;
    }

    const arrow = event.target.closest('[data-gallery-step]');
    if (arrow) {
      showGalleryImage(galleryIndex + Number(arrow.dataset.galleryStep));
      return;
    }

    const qtyButton = event.target.closest('[data-quantity-change]');
    if (qtyButton && quantity) {
      quantity.value = Math.max(1, Number(quantity.value || 1) + Number(qtyButton.dataset.quantityChange));
    }
  });

  select.addEventListener('change', () => setVariant(select.value));
  setVariant(select.value, { updateImage: true });
})();
